/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import cookie from "react-cookies";
import LeftMenu from "./LeftMenu";
import logo from "../../assets/images/brand/nautilusshipping.jpeg";
import users from "../../assets/images/users/21.jpg";
import { jsUcfirstFun } from "../Settings/Settings";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchkeyword:""
    };
    this.handleChangeText = this.handleChangeText.bind(this)
  }
  componentDidMount() {
    const script = document.createElement("script");
    script.src = "/assets/plugins/sidemenu/sidemenu.js";
    script.async = true;
    document.body.appendChild(script);

    const script2 = document.createElement("script");
    script2.src = "/assets/plugins/p-scroll/pscroll.js";
    script2.async = true;
    document.body.appendChild(script2);

    const script3 = document.createElement("script");
    script3.src = "/assets/js/custom.js";
    script3.async = true;
    document.body.appendChild(script3);
    
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  logout(e) {
   e.preventDefault();
    localStorage.removeItem('token')
    localStorage.removeItem('nemouserId')
    localStorage.removeItem('permissions')
    this.props.history.push('/')
  }

  handleChangeText(event) {
    const name = event.target.name;
    let value = event.target.value;
    this.setState({ [name]: value });
  }
  handleKeyDown = (event) => {
    if(event.key==='Enter') {
      this.props.history.push({
        pathname: `/search`,
        state: { searchkeyword: this.state.searchkeyword },
      });
    }
  };

  render() {
    var currentPage = this.props.currentPage;
    const EmployeeName = cookie.load("EmployeeName") ?? "";
    const firstName = localStorage.getItem('firstName') || '';
    const userName = localStorage.getItem('userName') || '';
    const displayName = (firstName!=="" && firstName!==null && firstName!=="null")?firstName:userName;
    return (
      <div>
        <div className="app-header header sticky">
          <div className="container-fluid main-container">
            <div className="d-flex">
              <a
                aria-label="Hide Sidebar"
                className="app-sidebar__toggle"
                data-bs-toggle="sidebar"
                href={void 0}
              ></a>

              <a className="logo-horizontal " href="index.html">
                <img
                  src={logo}
                  className="header-brand-img desktop-logo"
                  alt="logo"
                />
                <img
                  src={logo}
                  className="header-brand-img light-logo1"
                  alt="logo"
                  style={{ width: "100px" }}
                />
              </a>

              <div className="main-header-center ms-3 d-none d-lg-block">
                <input
                  type="text"
                  className="form-control"
                  id="typehead"
                  placeholder="Search for results..."
                  autoComplete="off"
                  name="searchkeyword"
                  value={this.state.searchkeyword}
                  placeholder="Search...." onChange={this.handleChangeText} onKeyDown={this.handleKeyDown}  
                />
                <button className="btn px-0 pt-2">
                  <i className="fe fe-search" aria-hidden="true"></i>
                </button>
              </div>
              <div className="d-flex order-lg-2 ms-auto header-right-icons">
                <button
                  className="navbar-toggler navresponsive-toggler d-lg-none ms-auto"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent-4"
                  aria-controls="navbarSupportedContent-4"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon fe fe-more-vertical"></span>
                </button>
                <div className="navbar navbar-collapse responsive-navbar p-0">
                  <div
                    className="collapse navbar-collapse"
                    id="navbarSupportedContent-4"
                  >
                    <div className="d-flex order-lg-2">
                      <div className="dropdown d-lg-none d-flex">
                        <a
                          href={void 0}
                          className="nav-link icon"
                          data-bs-toggle="dropdown"
                        >
                          <i className="fe fe-search"></i>
                        </a>
                        <div className="dropdown-menu header-search dropdown-menu-start">
                          <div className="input-group w-100 p-2">
                            <input
                              type="text"
                              className="form-control"
                              name="searchkeyword"
                              value={this.state.searchkeyword}
                              placeholder="Search...." onChange={this.handleChangeText} onKeyDown={this.handleKeyDown}  
                            />
                            <div className="input-group-text btn btn-primary">
                              <i
                                className="fa fa-search"
                                aria-hidden="true"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="dropdown d-flex header-settings">
                        <a
                          href={void 0}
                          className="nav-link icon"
                          data-bs-toggle="sidebar-right"
                          data-target=".sidebar-right"
                        >
                          Welcome {jsUcfirstFun(displayName)}
                        </a>
                      </div>

                      <div className="dropdown d-flex profile-1">
                        <a
                          href={void 0}
                          data-bs-toggle="dropdown"
                          className="nav-link leading-none d-flex"
                        >
                          <img
                            src={users}
                            alt="profile-user"
                            className="avatar  profile-user brround cover-image"
                          />
                        </a>
                        <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                          <div className="drop-heading">
                            <div className="text-center">
                              <h5 className="text-dark mb-0 fs-14 fw-semibold">
                                {EmployeeName}
                              </h5>
                              <small className="text-muted">{jsUcfirstFun(displayName)}</small>
                            </div>
                          </div>
                          <div className="dropdown-divider m-0"></div>
                          {/*  <a className="dropdown-item" href="profile.html">
                            <i className="dropdown-icon fe fe-user"></i> Profile
                          </a>
                          <a className="dropdown-item" href="email-inbox.html">
                            <i className="dropdown-icon fe fe-mail"></i> Inbox
                            <span className="badge bg-danger rounded-pill float-end">
                              5
                            </span>
                          </a>
                          <a className="dropdown-item" href="lockscreen.html">
                            <i className="dropdown-icon fe fe-lock"></i>{" "}
                            Lockscreen
                          </a> */}
                          <a
                            className="dropdown-item"
                            href={"/"}
                            onClick={this.logout.bind(this)}
                          >
                            <i className="dropdown-icon fe fe-alert-circle"></i>{" "}
                            Sign out
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <LeftMenu currentPage={currentPage} />
      </div>
    );
  }
}

export default Header;
